import React from "react";

const SidebarButton = ({ open, setopen, ...props }) => {
  const isExpanded = open ? true : false;

  return (
    <div
      aria-label="Toggle menu"
      aria-expanded={isExpanded}
      onClick={() => setopen(!open)}
      {...props}
    >
      <span
        className={`${
          open ? "rotate-45" : "rotate-0 "
        } bg-white transform origin-center relative w-8 h-1 rounded-md transition-all duration-300 ease-linear`}
        style={{ transformOrigin: "1px" }}
      /> 
      <span
        className={`${
          open ? "opacity-0" : "opacity-100"
        } transform relative w-8 h-1 bg-white rounded-md transition-all duration-300 ease-linear`}
        style={{ transformOrigin: "1px" }}
      />
      <span
        className={`${
          open ? "-rotate-45" : "rotate-0"
        } transform relative w-8 h-1 bg-white rounded-md transition-all duration-300 ease-linear`}
        style={{ transformOrigin: "1px" }}
      />
    </div>
  );
};

export default SidebarButton;
